import { RedCapital, SelectedCountry } from "@/configuration";
import store from "@/store";
import api from "./api";

export const orderComunas = (comunas: Array<any>) => {
  return comunas.sort( function( a, b ){
    if( a.name < b.name ){ return -1; }
    if( a.name > b.name ){ return 1; } 
    return 0;
  });
};

export const ProjectsMath = {
  minAmountToInvest(project: any): number {
    let amountLeft = project.monto - this.currentAmountInvested(project);
    // @ts-ignore
    return amountLeft < RedCapital[SelectedCountry].Project.MinInvest
      ? amountLeft
      // @ts-ignore
      : RedCapital[SelectedCountry].Project.MinInvest;
  },
  maxAmountToInvest(project: any): number {
    let amountLeft = project.monto - this.currentAmountInvested(project);
    return amountLeft;
  },
  currentAmountInvested(project: any): number {
    if (project.get_monto_proyecto != null) {
      return parseInt(project.get_monto_proyecto.monto);
    } else {
      return 0;
    }
  },
  currentAmountReserved(project: any): number {
    if (project.get_monto_reserva != null) {
      return parseInt(project.get_monto_reserva.reserva);
    } else {
      return 0;
    }
  },
  currentAmountTemporals(project: any): number {
    if (project.get_monto_proyecto_inversion_tmp != null) {
      return parseInt(project.get_monto_proyecto_inversion_tmp.monto);
    } else {
      return 0;
    }
  }
};

export const ProjectText = {
  timeLimitText(project: any) {
    if (project.credito_tipo.id == 1) {
      return project.cuotas == 1
        ? `${project.cuotas} Dia`
        : `${project.cuotas} Dias`;
    } else {
      return project.cuotas == 1
        ? `${project.cuotas} Mes`
        : `${project.cuotas} Meses`;
    }
  }
};

export const SimulationLogic = {
  getInvestmentPayload(
    investmentId: number,
    amountToInvest: any,
    project: any,
    paymentData: any,
    simulation: any,
    code: any,
    paymentGateway: number
  ) {
    let payload: any = {
      projectId: project.id,
      transaction: `${project.id}`,
      subject: `${project.nombre}`,
      amount: 0,
      investment: 0,
      isReserving: paymentData.isReserving,
      isJoiningClub: false,
      isPartner: false,
      paymentGateway,
      investmentId,
      code
    };

    if (paymentData.partnerState == 2) {
      payload.isPartner = true;
      payload.isJoiningClub = false;
    } else {
      payload.isJoiningClub = paymentData.isJoiningClub;
    }

    if (paymentData.partnerState == 1) {
      payload.isPartner = true;
      payload.isReserving = false;
      payload.isJoiningClub = false;
    }

    if (payload.isReserving && !payload.isJoiningClub && !payload.isPartner) {
      // CASO 1
      payload.amount = simulation.cobroDerechos; // cobroDerechos
      payload.investment = amountToInvest - simulation.cobroDerechos; // montoAInvertir - cobroDerechos
    } else if (
      payload.isReserving &&
      payload.isJoiningClub &&
      !payload.isPartner
    ) {
      // CASO 3
      // @ts-ignore
      payload.amount =
        simulation.cobroDerechos +
        // @ts-ignore
        RedCapital[SelectedCountry].Project.ClubAmount; // cobroDerechos + montoClub
      payload.investment = amountToInvest - simulation.cobroDerechos; // montoAInvertir - cobroDerechos
    } else if (
      payload.isReserving &&
      !payload.isJoiningClub &&
      payload.isPartner
    ) {
      // CASO 2
      payload.amount = 0; // No paga nada por que es socio del club
      payload.investment = amountToInvest; // montoAInvertir
    } else if (
      !payload.isReserving &&
      !payload.isJoiningClub &&
      !payload.isPartner
    ) {
      // CASO 4
      payload.amount = amountToInvest; // montoAInvertir
      payload.investment = 0; // No queda nada en saldo pendiente
    } else if (
      !payload.isReserving &&
      !payload.isJoiningClub &&
      payload.isPartner
    ) {
      // CASO 5
      payload.amount = amountToInvest; // montoAInvertir
      payload.investment = 0; // No queda nada en saldo pendiente
    } else if (
      !payload.isReserving &&
      payload.isJoiningClub &&
      !payload.isPartner
    ) {
      // CASO 6
      // @ts-ignore
      payload.amount =
        // @ts-ignore
        amountToInvest + RedCapital[SelectedCountry].Project.ClubAmount; // montoAInvertir + montoClub
      payload.investment = 0; // No queda saldo pendiente
    }

    if (
      payload.isReserving &&
      !payload.isJoiningClub &&
      !payload.isPartner &&
      simulation.cobroDerechos == 0
    ) {
      // CASO 7
      payload.amount = 1; // Un peso porque si
      payload.investment = amountToInvest; // La inversion queda en saldo pendiente
    }

    return payload;
  }
};

export const DniTrim = {
  string(s: string) {
    var r = s.replace(new RegExp(/\./g), "");
    var r = r.replace(new RegExp(/\-/g), "");
    return r;
  }
};
export const DniTrimCo = {
  string(s: string) {
    var r = s.replace(new RegExp(/\./g), "");
    return r;
  }
};

export const validaNit = {
  string(myNit:string){
    var vpri,
        x,
        y,
        aux,
        z;  
    myNit = myNit.replace (new RegExp(/\s/g), "" ) ; // Espacios
    myNit = myNit.replace (new RegExp(/,/g),  "" ) ; // Comas
    myNit = myNit.replace (new RegExp(/\./g), "" ) ; // Puntos
    myNit = myNit.replace (new RegExp(/-/g),  "" ) ; // Guiones    
    vpri = new Array(16) ; 
    z = myNit.length ;

    vpri[1]  =  3 ;
    vpri[2]  =  7 ;
    vpri[3]  = 13 ; 
    vpri[4]  = 17 ;
    vpri[5]  = 19 ;
    vpri[6]  = 23 ;
    vpri[7]  = 29 ;
    vpri[8]  = 37 ;
    vpri[9]  = 41 ;
    vpri[10] = 43 ;
    vpri[11] = 47 ;  
    vpri[12] = 53 ;  
    vpri[13] = 59 ; 
    vpri[14] = 67 ; 
    vpri[15] = 71 ;

    x = 0 ;
    y = 0 ;
    for  ( var i = 0; i < z; i++ )  {       
      y = ( myNit.substring (i, 1 ) ) ;  
      x += ( parseInt(y) * vpri [z-i] ) ;
    }
    y = x % 11 ;
    aux=( y > 1 ) ? 11 - y : y ;
  //  console.log("aux: " + aux)
    return aux;
  }
};

export const AccountTrim = {
  string(s: string) {
    var r = s.replace(new RegExp(/-/), "");
    return r;
  }
};

export const Uri = {
  string(s: string) {
    var r = s.replace(new RegExp(/%2F/g), "/");
    return r;
  }
};

export const Normalizer = {
  string(s: string) {
    var r = s.toLowerCase();
    r = r.replace(new RegExp(/\s/), " ");
    r = r.replace(new RegExp(/[àáâãäå]/g), "a");
    r = r.replace(new RegExp(/æ/g), "ae");
    r = r.replace(new RegExp(/ç/g), "c");
    r = r.replace(new RegExp(/[èéêë]/g), "e");
    r = r.replace(new RegExp(/[ìíîï]/g), "i");
    r = r.replace(new RegExp(/ñ/g), "n");
    r = r.replace(new RegExp(/[òóôõö]/g), "o");
    r = r.replace(new RegExp(/œ/g), "oe");
    r = r.replace(new RegExp(/[ùúûü]/g), "u");
    r = r.replace(new RegExp(/[ýÿ]/g), "y");
    r = r.replace(new RegExp(/\W/g), "");
    return r;
  }
};

export const isRutValid = (rut_complete: any) => {
  let clean_rut = rut_complete.replace(/[^k0-9]/gi, "").split("");

  let rut: any = clean_rut.slice(0, -1).join("");
  let dv: any = clean_rut
    .slice(clean_rut.length - 1, clean_rut.length)
    .toString();

  let i = 2;
  let sum = 0;

  rut
    .split("")
    .reverse()
    .forEach((el: any) => {
      if (i == 8) {
        i = 2;
      }
      sum += parseInt(el) * i;
      ++i;
    });

  let dvr: any = 11 - (sum % 11);

  if (dvr == 11) dvr = 0;
  if (dvr == 10) dvr = "K";
  return dvr.toString().toUpperCase() == dv.toUpperCase();
};



export const isNitValid = (nit: any, tipo_documento: any) => {

    if(tipo_documento == 3){
      const mods = [71, 67, 59, 53, 47, 43, 41, 37, 29, 23, 19, 17, 13, 7, 3];
 
      nit = nit.replace(/\./g, "");
      nit = nit.replace(" ", "");
      nit = nit.replace("-", "");
      const posiciones: number[] = [];
      if(nit.length < 10 && nit > 800000000 && nit < 999999999){
          const nit_mod = nit.length < 15 ? "0".repeat(15 - nit.length) + nit : nit;
          for(let i=0; i < 15; i++){
              posiciones.push(nit_mod[i] * mods[i]);
          }
          const total = posiciones.reduce(function(previous, current){
              return previous + current
          }, 0);
          const residuo = total % 11;
          let digito_verificacion = 0;
          if(residuo == 0){
              digito_verificacion = 0;
          }
          else if(residuo == 1){
              digito_verificacion = 1;
          }
          else {
              digito_verificacion = 11 - residuo;
          }
          const largo = nit.length + 1;
        // console.log(nit, digito_verificacion, (largo == 10) ? true : false, '< 10')
          return largo == 10 ? true : false
      }
      else if(nit.length == 10 && nit > 8000000000 && nit < 9999999999){
          for(let i = 0; i < 9; i++){
              posiciones.push(nit[i] * mods[i+6]);
          }
          let v = posiciones.reduce(function(previous, current){
              return previous + current
          }, 0);
          v = v % 11;
          if(v >= 2){
              v = 11 - v;
          }
          if(v == nit[9]){
              nit = nit.replace(-1, "");
             // console.log(nit, v, true, '1 = 10')
              return true;
          }else{
              v =  nit.substr(-1);
              nit = nit.replace(-1, "");
            // console.log(nit, v, false, '2 = 10')
              return false;
          }
      }else{
          const v =  nit.substr(-1);
          nit = nit.replace(-1, "");
        // console.log(nit, v, false, 'else')
          return false;
      }
    }else if(tipo_documento == 1){
      if(nit.length <= 13 && nit.length > 6){
        return true;
      }
      return false;
    }else if(tipo_documento == 2){
      if(nit.length <= 13 && nit.length > 5){
        return true;
      }
      return false;
    }else if(tipo_documento == 4){
      if(nit.length <= 13 && nit.length > 7){
        return true;
      }
      return false;
    }
  }


export const rutParser = (rut: any) => {
  rut = rut.replace(/[^k0-9]/gim, "").split("");
  return rut.length > 1
    ? `${parseInt(rut.slice(0, -1).join("")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}-${
        rut[rut.length - 1]
      }`
    : rut.join("");
};

export const rutParserCol = (nit: any) => {
  nit = nit.replace(/[^0-9]/gim, "").split("");
  return nit.length > 1
    ? `${parseInt(nit.slice(0, -1).join("")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}-${nit[nit.length - 1]}`: nit.join("");
};

export const isUserLogin = (cb: Function, reject?: Function) => {
  if (store.state.user != null) {
    cb();
  } else {
    if (reject !== undefined) reject();
  }
};

export const numeroALetras = (function() {
  // Código basado en https://gist.github.com/alfchee/e563340276f89b22042a
  // ...
  // https://independent.typepad.com/.a/6a00d8341c595453ef01bb08f0cf72970d-500wi
  function Unidades(num: number) {
    switch (num) {
      case 1:
        return "UN";
      case 2:
        return "DOS";
      case 3:
        return "TRES";
      case 4:
        return "CUATRO";
      case 5:
        return "CINCO";
      case 6:
        return "SEIS";
      case 7:
        return "SIETE";
      case 8:
        return "OCHO";
      case 9:
        return "NUEVE";
    }

    return "";
  }
  function Decenas(num: number) {
    let decena = Math.floor(num / 10);
    let unidad = num - decena * 10;

    switch (decena) {
      case 1:
        switch (unidad) {
          case 0:
            return "DIEZ";
          case 1:
            return "ONCE";
          case 2:
            return "DOCE";
          case 3:
            return "TRECE";
          case 4:
            return "CATORCE";
          case 5:
            return "QUINCE";
          default:
            return "DIECI" + Unidades(unidad);
        }
      case 2:
        switch (unidad) {
          case 0:
            return "VEINTE";
          default:
            return "VEINTI" + Unidades(unidad);
        }
      case 3:
        return DecenasY("TREINTA", unidad);
      case 4:
        return DecenasY("CUARENTA", unidad);
      case 5:
        return DecenasY("CINCUENTA", unidad);
      case 6:
        return DecenasY("SESENTA", unidad);
      case 7:
        return DecenasY("SETENTA", unidad);
      case 8:
        return DecenasY("OCHENTA", unidad);
      case 9:
        return DecenasY("NOVENTA", unidad);
      case 0:
        return Unidades(unidad);
    }
  }
  function DecenasY(strSin: string, numUnidades: number) {
    return numUnidades > 0 ? `${strSin} Y ${Unidades(numUnidades)}` : strSin;
  }
  function Centenas(num: number) {
    let centenas = Math.floor(num / 100);
    let decenas = num - centenas * 100;

    switch (centenas) {
      case 1:
        if (decenas > 0) return "CIENTO " + Decenas(decenas);
        return "CIEN";
      case 2:
        return "DOSCIENTOS " + Decenas(decenas);
      case 3:
        return "TRESCIENTOS " + Decenas(decenas);
      case 4:
        return "CUATROCIENTOS " + Decenas(decenas);
      case 5:
        return "QUINIENTOS " + Decenas(decenas);
      case 6:
        return "SEISCIENTOS " + Decenas(decenas);
      case 7:
        return "SETECIENTOS " + Decenas(decenas);
      case 8:
        return "OCHOCIENTOS " + Decenas(decenas);
      case 9:
        return "NOVECIENTOS " + Decenas(decenas);
    }

    return Decenas(decenas);
  }
  function Seccion(
    num: number,
    divisor: number,
    strSingular: string,
    strPlural: string
  ) {
    let cientos = Math.floor(num / divisor);
    let resto = num - cientos * divisor;

    let letras = "";

    if (cientos > 0)
      letras = cientos == 1 ? strSingular : `${Centenas(cientos)} ${strPlural}`;

    if (resto > 0) letras += "";

    return letras;
  }
  function Miles(num: number) {
    let divisor = 1000;
    let cientos = Math.floor(num / divisor);
    let resto = num - cientos * divisor;

    let strMiles = Seccion(num, divisor, "UN MIL", "MIL");
    let strCentenas = Centenas(resto);

    if (strMiles == "") return strCentenas;
    return `${strMiles} ${strCentenas}`;
  }

  function millon(num: number, singular: boolean) {
    var letraMillon = "";
    if (singular == true) letraMillon = "UN MILLON";
    else letraMillon = "MILLONES";
    if (num % 1000000 == 0) letraMillon = letraMillon + " DE";
    return letraMillon;
  }

  function Millones(num: number) {
    let divisor = 1000000;
    let cientos = Math.floor(num / divisor);
    let resto = num - cientos * divisor;

    let strMillones = Seccion(
      num,
      divisor,
      millon(num, true),
      millon(num, false)
    );
    let strMiles = Miles(resto);

    if (strMillones == "") return strMiles;

    return `${strMillones} ${strMiles}`;
  }
  return function NumeroALetras(num: number, currency: any) {
    currency = currency || {};
    let data = {
      numero: num,
      enteros: Math.floor(num),
      centavos: Math.round(num * 100) - Math.floor(num) * 100,
      letrasCentavos: "",
      letrasMonedaPlural: currency.plural || "PESOS CHILENOS", //'PESOS', 'Dólares', 'Bolívares', 'etcs'
      letrasMonedaSingular: currency.singular || "PESO CHILENO", //'PESO', 'Dólar', 'Bolivar', 'etc'
      letrasMonedaCentavoPlural: currency.centPlural || "CENTIMOS CHILENOS",
      letrasMonedaCentavoSingular: currency.centSingular || "CENTIMO CHILENO"
    };

    if (data.centavos > 0) {
      data.letrasCentavos = `CON ${Millones(data.centavos)} ${
        data.centavos == 1
          ? data.letrasMonedaCentavoSingular
          : data.letrasMonedaCentavoPlural
      }`;
    }

    if (data.enteros == 0) {
      return `CERO ${data.letrasMonedaPlural} ${data.letrasCentavos}`;
    }
    if (data.enteros == 1) {
      return `${Millones(data.enteros)} ${data.letrasMonedaSingular} ${
        data.letrasCentavos
      }`;
    } else {
      return `${Millones(data.enteros)} ${data.letrasMonedaPlural} ${
        data.letrasCentavos
      }`;
    }
  };
})();

export function formatNumber(n:any) {
  // format number 1000000 to 1.234.567
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export function formatNumberDecimal(n:any) {
  // format number 1000000 to 1.234.567,0000
  var parts = n.toString().split(".");
  const numberPart = parts[0];
  const decimalPart = parts[1];
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  
  return numberPart.replace(thousands, ".") + (decimalPart ? "," + decimalPart : "");
}

export function formatCurrency(input: string, blur?: string) {
  let simbolo = ""
  var input_val = input;
  

  // don't validate empty input
  if (input_val === "") { return; }

  // check for decimal
  if (input_val.indexOf(",") >= 0) {

      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      var decimal_pos = input_val.indexOf(",");

      // split number by decimal point
      var left_side = input_val.substring(0, decimal_pos);
      var right_side = input_val.substring(decimal_pos);

      // add commas to left side of number
      left_side = formatNumber(left_side);

      // validate right side
      // right_side = formatNumber(right_side);

      // On blur make sure 2 numbers after decimal
      if (blur === "blur") {
          right_side += "0000";
      }

      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 5);

      // join number by .
      input_val = simbolo + left_side + right_side;

  } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      input_val = formatNumber(input_val);
      input_val = simbolo + input_val;

      // final formatting
      if (blur === "blur") {
          input_val += ",0000";
      }
  }

  // send updated string to input
  input = input_val;
  return input;
}

export function transformEmpresaArrayData(array:any){

  let empresas_vinculadas = array.filter((empresa:any) => empresa.validado == 1);
  const arrayEmpresas = empresas_vinculadas.map((empresa: any) => {
      const empresaData = {...empresa, 'nombre': empresa.empresa && empresa.empresa.nombre};
      return empresaData;
  });

  return arrayEmpresas;

}

export async function obtenerProductosArray(){
  const request = await api.getTiposProductos();
  const response = request.data;

  return  JSON.parse(response.data);
}

export async function obtenerRegionesArray(){
  const request = await api.getRegiones();
  const response = request.data;

  return  JSON.parse(response.data);
}

export async function obtenerDepartamentosArray(){
  const request = await api.getDepartamentos();
  const response = request.data;

  return response.data;
}

export async function obtenerMunicipiosArray(departamento:number){
  const request = await api.getMunicipios(departamento);
  const response = request.data;

  return response.data;
}

export async function obtenerCiiusArray(){
  const request = await api.getCiius();
  const response = request.data;
  
  return response.data;
}

export async function obtenerVolumenesEmpresasArray(){
  const request = await api.getVolumenesEmpresas();
  const response = request.data;
  
  return response.data;
}

export async function generatePDF(type:string, name: string, payload = null){
  const payloadData = {
      type,
      payload
  }
  
  const { status, data } = await api.generatePDF(payloadData);

  const date = new Date();
  const formattedDate = date.toISOString().replace(/[-:.]/g, "").slice(0, 15);

  if(status === 200){
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}_${formattedDate}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
  } else {
      throw new Error('Fallo la descarga');
  }
}